export default "__VITE_ASSET__463bda4a__"